/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Invalid_TargetInputs */

const en_ledger_error_invalid_target = /** @type {(inputs: Ledger_Error_Invalid_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This classification is not in the current statement tree`)
};

const nl_ledger_error_invalid_target = /** @type {(inputs: Ledger_Error_Invalid_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze classificatie zit niet in de huidige stamboom`)
};

/**
* | output |
* | --- |
* | "This classification is not in the current statement tree" |
*
* @param {Ledger_Error_Invalid_TargetInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_invalid_target = /** @type {((inputs?: Ledger_Error_Invalid_TargetInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Invalid_TargetInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_invalid_target(inputs)
	return en_ledger_error_invalid_target(inputs)
});